import React, { Component } from "react";
import emailjs from 'emailjs-com';
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import FooterTwo from "../component/footer/FooterTwo";
import PaymentModal from "../elements/callaction/PaymentModal";


class ServiceDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false,
          showModal: false,
          selectedService: "",
          name: "",
          email: "",
          phone: "",
          paymentLink: ""
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    handlePaymentClick = (service, link) => {
        // this.setState({ showModal: true, selectedService: service, paymentLink: link });

        // No need for the modal since mainstack collects user data
        // Redirect to payment page
        window.open(link, "_blank");
    };
    
    handleInputChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };
    
    handleSubmit = (event) => {
        event.preventDefault();
        
        const { name, email, phone, paymentLink } = this.state;
        
        if (!name || !email || !phone) {
            alert("Please fill in all fields before proceeding.");
            return;
        }

        const templateParams = {
            from_name: name,
            from_email: email,
            phone_number: phone,
            service_name: "Change Leadership",
            payment_link: paymentLink,
        };
          
        emailjs.send('30n55zb', 'template_07g0ktb', templateParams, 'mznTwnc4RFD-CG9XN')
            .then((response) => {
                console.log('SUCCESS!', response.status, response.text);
                // Redirect to payment page
                window.open(paymentLink, "_blank");
                    
                // Close the modal
                this.setState({ showModal: false });
            })
            .catch((err) => {
                console.error('FAILED...', err);
                alert('FAILED...', err);
            });
    };
    render(){
        return(
            <React.Fragment>
                
                {/* Start Pagehelmet  */}
                <PageHelmet pageTitle='Service Details' />
                {/* End Pagehelmet  */}

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />

                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190"  data-black-overlay="10">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">Change Leadership</h2>
                                    <p>Driving Transformation, Inspiring Teams</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Page Wrapper */}
                <div className="rn-service-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="service-details-inner">
                                    <div className="inner">
                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-6 col-12">
                                                <div className="thumb">
                                                    <img className="w-100" src="/assets/images/service/leadership.jpg" alt="Service Images"/>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-12">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <p>In a business landscape defined by constant flux, the ability to lead transformative change is a critical differentiator. This bespoke coaching service, "Change Leadership," equips you with the strategic frameworks and practical tools to not just manage change, but to inspire teams and drive sustainable transformation.</p>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                        {/* Start Single Area */}
                                        <div className="row sercice-details-content align-items-center">
                                            <div className="col-lg-8 col-12 order-2 order-lg-1">
                                                <div className="details mt_md--30 mt_sm--30">
                                                    <h5 className="title mt-3">Why I Created This Mentoring Service</h5>
                                                    <p>After decades of witnessing organisations falter in the face of change, I realised the need for a focused mentorship Program that cultivates true change leaders. This service is designed to bridge the gap between reactive change management and proactive, transformative leadership.</p>

                                                    <h5 className="title mt-3">Mentorship Plan</h5>
                                                    <ul className="liststyle">
                                                        <li>Phase 1: Understanding the Psychology of Change: Exploring the human element of change and building emotional intelligence</li>
                                                        <li>Phase 2: Developing a Strategic Change Framework: Creating a roadmap for successful transformation initiatives.</li>
                                                        <li>Phase 3: Communicating Vision & Building Consensus: Mastering the art of influence and stakeholder engagement.</li>
                                                        <li>Phase 4: Empowering Teams & Navigating Resistance: Fostering a culture of adaptability and overcoming organisational barriers.</li>
                                                        <li>Phase 5: Driving Sustainable Transformation & Legacy: Creating lasting impact and building a legacy of positive change.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">In this mentorship, you will learn how to:</h5>
                                                    <ul className="liststyle">
                                                        <li>Develop a strategic change leadership framework.</li>
                                                        <li>Communicate vision and build consensus effectively.</li>
                                                        <li>Empower teams to embrace change and overcome resistance.</li>
                                                        <li>Navigate complex organisational dynamics.</li>
                                                        <li>Drive sustainable transformation and create a lasting impact.</li>
                                                        <li>Navigate change management and stakeholder resistance.</li>
                                                        <li>Expand your professional network and find PM career opportunities.</li>
                                                        <li>Develop industry-specific knowledge and expertise.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">What will you gain?</h5>
                                                    <p>By the end of this mentorship, you will gain:</p>
                                                    
                                                    <ul className="liststyle">
                                                        <li>A personalised change leadership strategy</li>
                                                        <li>Advanced communication and stakeholder engagement skills.</li>
                                                        <li>The ability to build and lead high-performing, adaptable teams.</li>
                                                        <li>Enhanced strategic thinking and problem-solving abilities.</li>
                                                        <li>The confidence to drive transformative change and advance your career.</li>
                                                    </ul>

                                                    <h5 className="title mt-3">Who is this mentorship program for?</h5>
                                                    <ul className="liststyle">
                                                        <li>Leaders at all levels: Individuals responsible for driving change initiatives within their teams or organisations.</li>
                                                        <li>Managers and Supervisors: Professionals seeking to enhance their ability to lead teams through periods of transition and transformation.</li>
                                                        <li>Project Managers and Change Agents: Individuals directly involved in implementing and managing change projects.</li>
                                                        <li>Human Resources Professionals: Those responsible for fostering organisational development and managing the human impact of change.</li>
                                                        <li>Executives and Senior Leaders: Professionals aiming to cultivate a culture of adaptability and drive strategic transformation.</li>
                                                        <li>Entrepreneurs and Business Owners: Individuals needing to navigate change and growth within their businesses</li>
                                                    </ul>

                                                    <h5 className="title mt-3">How is the mentorship structured?</h5>
                                                    <p>This comprehensive 4-month Program features personalised one-on-one sessions, practical exercises, and ongoing support. You will also gain access to exclusive resources and a network of change leadership professionals.</p>

                                                    <h5 className="title mt-3">FAQs:</h5>
                                                    <ol className="liststyle">
                                                        <li>Is this mentorship suitable for professionals in all industries?</li>
                                                        <p style={{ listStyle: 'none' }}>Yes, the principles of change leadership are universally applicable across all sectors</p>

                                                        <li>Will this mentorship help me navigate organisational resistance?</li>
                                                        <p style={{ listStyle: 'none' }}>Absolutely. We dedicate a significant portion of the Program to strategies for overcoming resistance and building buy-in</p>

                                                        <li>How much time commitment is required for this mentorship?</li>
                                                        <p style={{ listStyle: 'none' }}>Expect to dedicate approximately 5 hours per week to mentorship sessions and practical application.</p>
                                                    </ol>

                                                    <div className="flex-wrap mt-5 align-items-center">
                                                        <h5 className="title mb-0 mr-3">Enrol Now £699</h5>

                                                        <div
                                                            className="payment-buttons btn btn-outline-danger d-inline-flex align-items-center px-3 py-2"
                                                            onClick={() => this.handlePaymentClick("Change Leadership", "https://mainstack.store/coachdoi/y-Ve7MxCzqVe")}
                                                            style={{ cursor: "pointer", borderRadius: "4px" }}
                                                        >
                                                            <span style={{ fontWeight: "500" }}>Pay with </span>
                                                            <img
                                                                src="/assets/images/icons/mainstack.png"
                                                                alt="Mainstack"
                                                                className="btn-icon ml-2 img-fluid"
                                                                style={{ height: "20px", maxWidth: "100%" }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* End Single Area */}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Page Wrapper */}

                <PaymentModal
                    show={this.state.showModal}
                    onClose={() => this.setState({ showModal: false })}
                    onSubmit={this.handleSubmit}
                    name={this.state.rnName}
                    email={this.state.rnEmail}
                    phone={this.state.rnPhone}
                    service={this.state.selectedService}
                    onChange={(e) => this.setState({ [e.target.name]: e.target.value })}
                />
                
                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <FooterTwo />

            </React.Fragment>
        )
    }
}
export default ServiceDetails;